import React from "react";
import { FaCreditCard } from "react-icons/fa";

/**
 * Coming-soon placeholder for the Card payment method.
 * P3.2 scope — Stripe integration lands in a follow-up.
 *
 * Rendered only when the user somehow activates the card tab
 * (shouldn't happen in v1 since the tab is disabled + click-gated
 * in PaymentMethodTabs, but defense in depth).
 */
export function CardPanel() {
  return (
    <div className="pay-coming-soon">
      <FaCreditCard size={36} />
      <div className="pay-coming-soon__title">Card payments coming soon</div>
      <div className="pay-coming-soon__note">
        Stripe-backed card checkout lands in P3.2. For now, use the wallet
        option on the left.
      </div>
    </div>
  );
}
